import React from 'react'
import Lanhu_1 from "../view/lanhu_1";
import Lanhu_2 from "../view/lanhu_2";
import Lanhu_3 from "../view/lanhu_3";
import Lanhu_4 from "../view/lanhu_4";
import WebCamera from '../view/lanhu_4/camera/WebCamera';
import Lanhu_5 from "../view/lanhu_5";
import Lanhu_7 from "../view/lanhu_7";
import Line from '../view/Line';

const routers = [
    {
        path: "/",
        element: <Lanhu_1 />,   // 主页
    },
    {
        path: "/lanhu_2",
        element: <Lanhu_2 />,   // 主题
    },
    {
        path: "/lanhu_5",
        element: <Lanhu_5 />,   // 知识点
    },
    {
        path: "/lanhu_3",
        element: <Lanhu_3 />,   // 视频列表
    },
    {
        path: "/lanhu_4",       // 视频观看
        element: <Lanhu_4 />
    },
    {
        path: "/lanhu_7",
        element: <Lanhu_7 />    // 考试
    },
    {
        path: "/camera",
        element: <WebCamera/>   // 人脸验证
    },
    {
        path: '/line',
        element: <Line/>        // 条线选择
    }
]

export default routers;